module.exports = __webpack_public_path__ + "assets/images/one_f75333c95c3eeaa90d431b853c651b92.png";